import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/estoque/gruposestoques/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findGrupoEstoque({
  empresa_cnpj,
  include = "",
  per_page = 1000,
  where = {},
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${queryWhere}${
      include ? `&include=${include}` : ""
    }${per_page && `&per_page=${per_page}`}`,
    "GET",
    headers
  );
}
